import {
  createComponentMapperModel,
  withCompInfo,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type { DocumentMediaProps } from '@wix/thunderbolt-components';
import type { DocumentMediaDefinition } from '@wix/thunderbolt-components/dist/components/DocumentMedia/DocumentMedia';
import type { IDocumentMediaStateValues } from '../DocumentMedia.types';
import {
  ariaNamespace,
  TranslationFallbacks,
  TranslationKeys,
} from '../constants';

export const props = withCompInfo<
  DocumentMediaProps,
  DocumentMediaDefinition,
  DocumentMediaProps
>()(
  [
    'compId',
    'fullNameCompType',
    'language',
    'trackClicksAnalytics',
    'translate',
  ],
  ({ translate, ...compInfo }, carmiData) => {
    const translations = {
      ariaLabel:
        translate(ariaNamespace, TranslationKeys.ariaLabel) ||
        TranslationFallbacks.ariaLabel,
    };
    return {
      ...carmiData,
      ...compInfo,
      translations,
    };
  },
);

const stateRefs = withStateRefsValues<keyof IDocumentMediaStateValues>([
  'reportBi',
]);

export default createComponentMapperModel({ props, stateRefs });
